<h2>{{ 'documentEditor.fields' | translate }}</h2>

@if (fields().length === 0) {
  <p class="empty">{{ 'documentEditor.noFields' | translate }}</p>
}

@for (field of fields(); track field.id) {
  <div class="field" [class.active]="field.id === focused()?.id" [attr.data-field-id]="field.id">
    <label [attr.for]="field.id">{{ field.label }}</label>

    @switch (field.kind) {
      @case (kind.CheckBox) {
        <input
          type="checkbox"
          [id]="field.id"
          [checked]="asChecked(field)"
          (change)="setChecked(field, $event)"
        />
      }
      @case (kind.DropDown) {
        <select [id]="field.id" [value]="asText(field)" (change)="setText(field, $event)">
          @for (option of field.options; track option.value) {
            <option [value]="option.value">{{ option.label }}</option>
          }
        </select>
      }
      @case (kind.Date) {
        <!--
          The date shows in the field's own notation, as in the document. Text that is
          not a date, such as "Onbekend", shows as the placeholder.
        -->
        <div class="date" [appDateFormat]="field.dateFormat">
          <input
            [id]="field.id"
            [matDatepicker]="picker"
            [value]="dateOf(field)"
            [placeholder]="dateText(field)"
            (dateChange)="setDate(field, $event)"
          />
          <mat-datepicker-toggle [for]="picker" />
          @if (dateOf(field)) {
            <button
              mat-icon-button
              type="button"
              class="clear-date"
              [attr.aria-label]="'documentEditor.unknownDate' | translate"
              [title]="'documentEditor.unknownDate' | translate"
              (click)="clearDate(field)"
            >
              <mat-icon>close</mat-icon>
            </button>
          }
          <mat-datepicker #picker panelClass="docx-date-calendar" />
        </div>
      }
      @default {
        <textarea
          [id]="field.id"
          cdkTextareaAutosize
          cdkAutosizeMinRows="1"
          [value]="asText(field)"
          [placeholder]="field.placeholder"
          (keydown.enter)="field.multiline || $event.preventDefault()"
          (input)="typeText(field, $event)"
          (change)="setText(field, $event)"
        ></textarea>
      }
    }
  </div>
}
